import React from 'react'
import {
  DropdownWrapper,
  LanguageWrapper,
  Select,
} from '../LanguageSwitcher/styles'
import { languages } from '@util/i18n/i18n'
import useLanguageSwitcher from '@hooks/use-language-switcher'

import { DropdownOption, Dropdown } from '@thriveglobal/thrive-ui-lib'

const LanguageSwitcher = () => {
  const { setLanguage, selectedLanguage } = useLanguageSwitcher()

  const handleChange = async (selected: DropdownOption) => {
    const languageCode = selected.value
    setLanguage(languageCode)
  }

  const getSelectedLanguage = () => {
    for (const entry of languages) {
      if (entry.value === selectedLanguage) {
        return entry
      }
    }
    return languages[0]
  }

  return (
    <LanguageWrapper>
      <DropdownWrapper
        defaultValue={getSelectedLanguage()}
        options={languages}
        onChange={handleChange}
      />
    </LanguageWrapper>
  )
}

export default LanguageSwitcher
